@if (position() === 'left') {
  @if (selected(); as banner) {
    <a [href]="banner.link || null"
       [target]="banner.link ? banner.target : null"
       [class.no-link]="!banner.link"
       data-content-target>
      <img
        [src]="PHXCDN + '/marketing-management/' + banner.image"
        [alt]="banner.title || 'Hageda Apothekenportal Links Skyscraper Ad'"
        class="ad-image"
        data-content-piece
        loading="eager">
    </a>
  }
} @else {
  @if (selected(); as banner) {
    <a [href]="banner.link || null"
       [target]="banner.link ? banner.target : null"
       [class.no-link]="!banner.link"
       data-content-target>
      <img
        [src]="PHXCDN + '/marketing-management/' + banner.image"
        [alt]="banner.title || 'Hageda Apothekenportal Rechts Skyscraper Ad'"
        class="ad-image"
        data-content-piece
        loading="eager">
    </a>
  }
}
